import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme: any) => ({
  calendarYear: {
    width: '100%',
    height: 'calc(100% - 16px)',
    padding: '8px 0',
  },
  months: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    width: 'calc(100% - 16px)',
    height: '100%',
    gap: '16px',
    overflow: 'auto',
    maxHeight: '100%',
    padding: '0 8px',
    '&::after': {
      content: `''`,
      display: 'block',
      width: '100%',
      height: '20px',
    },
  },
  month: {
    display: 'flex',
    flexDirection: 'column',
    width: '400px',
  },
  monthHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '8px',
    '& > span': {
      display: 'flex',
      width: 'fit-content',
      backgroundColor: theme.colors.white,
      marginBottom: '8px',
      padding: '4px 8px',
      fontWeight: '500',
      borderRadius: '12px',
      cursor: 'pointer',
    },
    '& > button': {
      color: theme.colors.primaryBlue[500],
      backgroundColor: theme.colors.white,
      '&:hover': {
        backgroundColor: theme.colors.grey[100],
      },
    }
  },
  weekdayHeader: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.colors.white,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: theme.colors.grey[335],
    borderRadius: '24px 24px 0 0',
    position: 'relative',
    zIndex: theme.zIndex.calendarHeader,
  },
  weekday: {
    width: 'calc(100% / 7)',
    padding: '10px',
    fontSize: '14px',
    '& p': {
      width: '100%',
      textAlign: 'center',
      marginBottom: '0',
    },
  },
  days: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    position: 'relative',
  },
  loadingWrapper: {
    position: "absolute",
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: theme.zIndex.calendarLoading,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: 'rgba(128,128,128,0.15)',
  },
  spinner: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    '& > svg': {
      color: theme.colors.primaryBlue[500],
    },
  },
}));

export default useStyles;